import {getEnvironment} from '../../../utils/Environment';
// import grid from '/assets/yourappshome/S_IlluArtAndIllu1000 _96.svg';
// import portrait from '/assets/yourappshome/S_IlluPhoto2LPortrait_96.svg';
// import letter from './icons/S_IlluPrintLetter_96.svg';
// import browser from '/assets/yourappshome/S_IlluWebiMac27_96.svg';
// import poster from './icons/S_IlluArtAndIlluPoster_96.svg';
// import iphone from './icons/S_IlluMobileIPhoneX_96.svg';
// import plus from './icons/Smock_AddCircle_18_N.svg';
// import newFile from '/assets/yourappshome/S_Illu_PsWeb_NewFile_160x120.svg';
// import psSecondary from './icons/S_SpotIllustration_Whatscoming_Ps.svg';
// import ilstSecondary from './icons/S_SpotIllustration_Whatscoming_Ai.svg';

import {AppHomeData, AppHomeUCSData, SophiaBannerItem} from './types';

const env = getEnvironment();

const fakeIllustratorBannerData: {
	fakeBanner: SophiaBannerItem;
} = {
	fakeBanner: {
		imageList: [
			{
				_publishUrl: `https://${window.location.host}/assets/aiw_welcome_banner.png`,
			},
		],
		backgroundColor: 'a8d4fb',
		isOpen: true,
		ingestDescription: 'default-ai-web-banner',
		textList: [
			'Welcome to Illustrator (Beta)', 'Edit and create vector graphics right in your browser.',
			'Take the Tour',
		],
		colorTextList: ['#FFFFFF'],
	},
};

const fakeIllustratorUCSResponse: {
	fakeResponse: AppHomeUCSData;
} = {
	fakeResponse: {
		appContextType: 'illustratorweb',
		totalAvailable: 3,
		items: [
			{
				componentType: 'banner',
				context: 'banner',
				title: 'illustrator banner',
			},
			{
				componentType: 'tabs',
				context: 'tabs',
				title: 'tabs',
				tabs: [
					{
						componentType: 'tab',
						context: 'home',
						icon: '3d-materials-smart',
						title: {
							long: 'Home',
						},
						cards: [
							{
								contentType: 'newFile',
								id: 'newFile',
								image: 'https://odin.adobe.com/content/dam/ccsurfaces/appsHome/en_US/photoshop/assets/S_Illu_PsWeb_NewFile_160x120.svg',
								title: {
									long: 'New File',
								},
							},
							{
								contentType: 'learnCard',
								id: 'Whats different',
								image: `https://${window.location.host}/assets/card-whats-different-2x.png`,
								subtitle: {
									long: 'Hands-on tutorial',
								},
								title: {
									long: 'What\'s different in Illustrator on the web',
								},
							},
							{
								contentType: 'learnCard',
								id: 'Card Editing',
								image: `https://${window.location.host}/assets/card-editing-workspace-2x.png`,
								subtitle: {
									long: 'Hands-on tutorial',
								},
								title: {
									long: 'Get to know Illustrator\'s editing workspace',
								},
							},
							{
								contentType: 'learnCard',
								id: 'Collaboration',
								image: `https://${window.location.host}/assets/card-collaboration-2x.png`,
								subtitle: {
									long: 'Hands-on tutorial',
								},
								title: {
									long: 'Exploring Illustrator\'s new collaboration features',
								},
							},
						],
					},
				],
			},
			{
				componentType: 'recents',
				context: 'recents',
				title: 'recents',
			},
		],
	},
};

const newCanvasLinks = {
	dev: {
		FRED: '#',
		PHSP: 'https://dev.photoshop.adobe.com/new',
		ILST: 'https://stage.illustrator.adobe.com/?new=true',
	},
	stage: {
		FRED: '#',
		PHSP: 'https://stage.photoshop.adobe.com/new',
		ILST: 'https://stage.illustrator.adobe.com/?new=true',
	},
	prod: {
		FRED: '#',
		PHSP: 'https://alpha.photoshop.adobe.com/new',
		ILST: 'https://preview.illustrator.adobe.com/?new=true',
	},
};

const newWebLargeLinks = {
	dev: {
		PHSP: 'https://dev.photoshop.adobe.com/?new=true&preset=Web%20Large',
	},
	stage: {
		PHSP: 'https://stage.photoshop.adobe.com/?new=true&preset=Web%20Large',
	},
	prod: {
		PHSP: 'https://alpha.photoshop.adobe.com/?new=true&preset=Web%20Large',
	},
};

const prevCanvasLinks = {
	dev: {
		FRED: 'https://dev.fred.corp.adobe.com',
		PHSP: 'https://dev.photoshop.adobe.com?urn=urn:aaid:sc:US:243767f5-14ed-48a8-81b0-e2e22b58ed03',
		ILST: 'https://stage.illustrator.adobe.com',
	},
	stage: {
		FRED: 'https://stage.fred.corp.adobe.com',
		PHSP: 'https://stage.photoshop.adobe.com?urn=urn:aaid:sc:US:243767f5-14ed-48a8-81b0-e2e22b58ed03',
		ILST: 'https://stage.illustrator.adobe.com',
	},
	prod: {
		FRED: 'https://canvas.adobe.com',
		PHSP: 'https://alpha.photoshop.adobe.com/?urn=urn:aaid:sc:US:243767f5-14ed-48a8-81b0-e2e22b58ed03',
		ILST: 'https://preview.illustrator.adobe.com',
	},
};

const appHomeData: {
	FRED: AppHomeData;
	PHSP: AppHomeData;
	ILST: AppHomeData;
} = {
	FRED: {
		name: 'Creative Cloud Canvas (Private Beta)',
		sapCode: 'FRED',
		subtitle: 'Lay out, visualize, and review creative work collaboratively.',
		// secondaryCta: {
		// 	title: 'New and upcoming features',
		// 	link: '',
		// 	linkText: 'Learn more',
		// 	analyticsId: '',
		// 	imgUrl: fredSecondary,
		// 	subtitle: '',
		// },
		startRow: {
			tabs: [
				{
					name: 'Home',
					type: 'tab',
					icon: 'Home',
					links: [
						{
							type: 'dialog',
							imgUrl: '/assets/new_canvas.svg',
							text: 'appHomes.files.newCanvas',
							link: newCanvasLinks[env].FRED,
							analyticsId: '',
						},
						{
							type: 'card',
							imgUrl: '/assets/dimmed_canvas_template_1.png',
							text: 'Brainstorming',
							link: newCanvasLinks[env].FRED,
							analyticsId: '',
						},
						{
							type: 'card',
							imgUrl: '/assets/dimmed_canvas_template_2.png',
							text: 'Design critique',
							link: newCanvasLinks[env].FRED,
							analyticsId: '',
						},
						{
							type: 'card',
							imgUrl: '/assets/dimmed_canvas_template_3.png',
							text: 'Campaign aggregator',
							link: newCanvasLinks[env].FRED,
							analyticsId: '',
						},
						// {
						// 	type: 'card',
						// 	imgUrl: '/assets/yourappshome/sketchy.png',
						// 	text: 'Sketchy Annotation Library',
						// 	link: newCanvasLinks[env]['FRED'],
						// 	analyticsId: '',
						// },
					],
				},
				// {
				// 	name: 'Learn',
				// 	type: 'tab',
				// 	icon: 'Learn',
				// 	links: [],
				// },
				// {
				// 	name: 'Files',
				// 	type: 'button',
				// 	icon: 'Folder Outline',
				// 	links: [],
				// },
			],
		},
		data: {
			backgroundColor: 'rgb(255, 232, 198)',
			bannerImgUrl: 'fredHeader.png',
			textColor: '#545454',
			comingSoonImgUrl: 'comingSoon.png',
		},
		errorModal: {
			creation: {
				title: 'appHomes.error.modal.canvas.title',
				description: 'appHomes.error.modal.canvas.description',
			},
			api: {
				title: 'appHomes.error.modal.canvas.title',
				description: 'appHomes.error.modal.canvas.refresh',
			},
			entitlement: {
				title: 'appHomes.error.modal.canvas.capability.title',
				description: 'appHomes.error.modal.canvas.capability.description',
			},
		},
	},
	PHSP: {
		name: 'Photoshop (Beta)',
		sapCode: 'PHSP',
		subtitle: 'Collaborate with stakeholders and try out a preview of editing in your browser.',
		// secondaryCta: {
		// 	title: 'New and upcoming features',
		// 	link: '',
		// 	linkText: 'Learn more',
		// 	analyticsId: '',
		// 	imgUrl: psSecondary,
		// 	subtitle: '',
		// },
		startRow: {
			tabs: [
				{
					name: 'Home',
					type: 'tab',
					icon: 'Home',
					links: [
						{
							type: 'dropbox',
							imgUrl: '/assets/S_Illu_PsWeb_NewFile_160x120.svg',
							text: 'New file',
							link: newCanvasLinks[env].PHSP,
							analyticsId: '',
						},
						{
							type: 'tutorial',
							imgUrl: '/assets/dimmed_photoshop_template_1.png',
							text: 'What\'s different in Photoshop on the web',
							link: newCanvasLinks[env].PHSP,
							analyticsId: '',
						},
						{
							type: 'tutorial',
							imgUrl: '/assets/dimmed_photoshop_template_2.png',
							text: 'Collaboration on the web',
							link: newCanvasLinks[env].PHSP,
							analyticsId: '',
						},
						{
							type: 'tutorial',
							imgUrl: '/assets/dimmed_photoshop_template_3.png',
							text: 'Introduction to adjusting photos',
							link: newCanvasLinks[env].PHSP,
							analyticsId: '',
						},
						// {
						// 	type: 'icon',
						// 	imgUrl: landscape,
						// 	text: 'Drag and drop images to import',
						// 	link: newCanvasLinks[env]['PHSP'],
						// 	analyticsId: '',
						// },
						// {
						// 	type: 'icon',
						// 	imgUrl: portrait,
						// 	text: 'Custom size',
						// 	link: newCanvasLinks[env]['PHSP'],
						// 	analyticsId: '',
						// },
						// {
						// 	type: 'icon',
						// 	imgUrl: portrait,
						// 	text: '7 x 5',
						// 	link: newCanvasLinks[env]['PHSP'],
						// 	analyticsId: '',
						// },
						// {
						// 	type: 'icon',
						// 	imgUrl: browser,
						// 	text: 'Web 1920',
						// 	link: newWebLargeLinks[env]['PHSP'],
						// 	analyticsId: '',
						// },
						// {
						// 	type: 'icon',
						// 	imgUrl: poster,
						// 	text: 'Poster',
						// 	link: newCanvasLinks[env]['PHSP'],
						// 	analyticsId: '',
						// },
						// {
						// 	type: 'icon',
						// 	imgUrl: letter,
						// 	text: 'Letter',
						// 	link: newCanvasLinks[env]['PHSP'],
						// 	analyticsId: '',
						// },
						// {
						// 	type: 'icon',
						// 	imgUrl: iphone,
						// 	text: 'iPhone 12',
						// 	link: newCanvasLinks[env]['PHSP'],
						// 	analyticsId: '',
						// },
						// {
						// 	type: 'icon',
						// 	imgUrl: grid,
						// 	text: 'More Presets',
						// 	link: prevCanvasLinks[env]['PHSP'],
						// 	analyticsId: '',
						// },
					],
				},
				// {
				// 	name: 'Learn',
				// 	type: 'tab',
				// 	icon: 'Learn',
				// 	links: [],
				// },
				// {
				// 	name: 'Discover',
				// 	type: 'tab',
				// 	icon: 'Globe Grid',
				// 	links: [],
				// },
				// {
				// 	name: 'Files',
				// 	type: 'button',
				// 	icon: 'Folder Outline',
				// 	links: [],
				// },
			],
		},
		data: {
			backgroundColor: 'rgb(165 212 252)',
			bannerImgUrl: 'photoshopWebHeader.png',
			backgroundPosition: 'center bottom 69%', // nice
			textColor: '#545454',
			btnVariant: 'primary',
			installUrl: '/apps/all/photoshop/installation',
			appName: 'photoshop',
		},
		errorModal: {},
	},
	ILST: {
		name: 'Illustrator',
		sapCode: 'ILST',
		subtitle: 'Create and co-edit Illustrator cloud files.',
		// secondaryCta: {
		// 	title: 'New and upcoming features',
		// 	link: '',
		// 	linkText: 'Learn more',
		// 	analyticsId: '',
		// 	imgUrl: ilstSecondary,
		// 	subtitle: '',
		// },
		startRow: {
			tabs: [
				{
					name: 'Home',
					type: 'tab',
					icon: 'Home',
					links: [
						{
							type: 'icon',
							imgUrl: '/assets/S_IlluPhoto2LPortrait_96.svg',
							text: 'Custom Size',
							link: newCanvasLinks[env].ILST,
							analyticsId: '',
						},
						{
							type: 'icon',
							imgUrl: '/assets/S_IlluPhoto2LPortrait_96.svg',
							text: '7 x 5',
							link: newCanvasLinks[env].ILST,
							analyticsId: '',
						},
						{
							type: 'icon',
							imgUrl: '/assets/S_IlluWebiMac27_96.svg',
							text: 'Web 1920',
							link: newCanvasLinks[env].ILST,
							analyticsId: '',
						},
						// {
						// 	type: 'icon',
						// 	imgUrl: poster,
						// 	text: 'Poster',
						// 	link: newCanvasLinks[env]['ILST'],
						// 	analyticsId: '',
						// },
						// {
						// 	type: 'icon',
						// 	imgUrl: letter,
						// 	text: 'Letter',
						// 	link: newCanvasLinks[env]['ILST'],
						// 	analyticsId: '',
						// },
						// {
						// 	type: 'icon',
						// 	imgUrl: iphone,
						// 	text: 'iPhone 12',
						// 	link: newCanvasLinks[env]['ILST'],
						// 	analyticsId: '',
						// },
						{
							type: 'icon',
							imgUrl: '/assets/S_IlluArtAndIllu1000 _96.svg',
							text: 'More Presets',
							link: prevCanvasLinks[env].ILST,
							analyticsId: '',
						},
					],
				},
				// {
				// 	name: 'Learn',
				// 	type: 'tab',
				// 	icon: 'Learn',
				// 	links: [],
				// },
				// {
				// 	name: 'Discover',
				// 	type: 'tab',
				// 	icon: 'Globe Grid',
				// 	links: [],
				// },
				// {
				// 	name: 'Files',
				// 	type: 'button',
				// 	icon: 'Folder Outline',
				// 	links: [],
				// },
			],
		},
		data: {
			backgroundColor: '#f5b171',
			installUrl: '/apps/all/illustrator/installation',
			appName: 'illustrator',
		},
		errorModal: {},
	},
};

export default appHomeData;
export {newCanvasLinks, fakeIllustratorUCSResponse, fakeIllustratorBannerData};
